import { CheckoutLauncher, createCartItemFromProduct } from '@gik/checkout';
import { Product } from '@gik/core/models/gik/Product';
import bemBlock from '@gik/core/utils/bemBlock';
import { formatCurrency } from '@gik/core/utils/format';
import { Button, HTMLParser, WordBone } from '@gik/ui';
import { UIButtonVariant } from '@gik/ui/types';
import React from 'react';
import { InkindPageViewHistoryItem } from '../InkindPageViewRecorder/InkindPageViewRecorder';

interface IGiftBoxOptionProps {
  title: string;
  inkindRouteId: string;
  product: Product | undefined;
  inkindPageViewHistory: InkindPageViewHistoryItem[];
  append?: string;
  prepend?: string;
  deluxe?: boolean;
}

export default function GiftBoxOption({
  title,
  prepend,
  append,
  product,
  inkindRouteId,
  inkindPageViewHistory,
  deluxe,
}: IGiftBoxOptionProps) {
  const giftboxCart = product ? [createCartItemFromProduct(product)] : [];
  const buttonVariant: UIButtonVariant = deluxe ? 'deluxe' : 'primary';

  const bem = bemBlock('gift-box-option');

  return (
    <section className={bem(undefined, deluxe ? 'deluxe' : 'standard')}>
      <div className={bem('title-wrapper')}>
        {prepend && (
          <p className={bem('prepend')}>
            <HTMLParser rawHtml={prepend} />
          </p>
        )}
        <p className={bem('title')}>
          <HTMLParser rawHtml={title} />
        </p>
      </div>
      {append && (
        <p className={bem('append')}>
          <HTMLParser rawHtml={append} />
        </p>
      )}
      <div className={bem('footer') /*TODO: use <footer> after SPA migration */}>
        <p className={bem('price')}>
          {product && <>{formatCurrency(product.price)}</>}
          {!product && <WordBone width={60} />}
        </p>
        <CheckoutLauncher
          cachedProducts={product ? [product] : undefined}
          cart={giftboxCart}
          initialInkindRouteId={inkindRouteId}
          skipProductsCheckoutStep={false}
          inkindPageViewHistory={inkindPageViewHistory}
          child={(onClick, isLoading) => (
            <Button
              variant={isLoading ? 'primary' : buttonVariant}
              loading={isLoading}
              disabled={isLoading}
              onClick={onClick}
            >
              SEND NOW
            </Button>
          )}
          initiatedOn="inkindPage"
        />
      </div>
    </section>
  );
}
